export const TREND_RP_COLOR = "var(--colors-info)";
export const TREND_RCN_COLOR = "var(--colors-secondary)";
export const TREND_RP_COLOR = "var(--colors-info)";
export const TREND_RCN_COLOR = "var(--colors-secondary)";
